import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BASE_WS_URL } from '../config/config';

export default function useAviatorSocket() {
  const dispatch = useDispatch();
  const aviator = useSelector((state) => state.aviator);

  useEffect(() => {
    const url = `${BASE_WS_URL}/aviator`;
    dispatch({ type: 'aviator/connect', payload: url });

    return () => {
      dispatch({ type: 'aviator/disconnect' });
    };
  }, [dispatch]);

  return aviator; // returns { lastMessage, status, roundId }
}
